import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import MDReactComponent from 'markdown-react-js';

import { media } from '../../../styles/style-utils';
import { legacyType } from '../../../styles/typography';
import { Body, Subheader } from './ArticleGridBlock';
import ReadMore from '../utils/ReadMore';
import Hyperlink from '../../common/Hyperlink';
import ArticleSubheader from './ArticleSubheader';
import { getMagazineArticleUrl } from '../../../../routes/util';
import { getArtworkUrl } from '../utils/Contentful';

const Item = styled.div`
  position: relative;

  img {
    margin-bottom: var(--fr);
    width: 100%;
    object-fit: cover;

    ${media.mediumLarge`
      height: calc(12 * var(--fr));
    `}

    ${media.extraLarge`
      height: calc(15 * var(--fr));
    `}
  }

  .preview {
    font-size: var(--fs-sm);
    ${legacyType('sm', 'body')};
    overflow: hidden;
    -webkit-line-clamp: 4; /* stylelint-disable-line property-no-vendor-prefix */
    -webkit-box-orient: vertical; /* stylelint-disable-line property-no-vendor-prefix */
    display: -webkit-box; /* stylelint-disable-line value-no-vendor-prefix */
    word-break: break-word;

    p {
      display: inline;
    }
  }

  h2 {
    font-size: var(--fs-ml);
    margin: 1rem 0;
  }
`;

const ArticleGridItem = ({ content }) => {
  const { title, excerpt, featuredImage, slug, category } = content;
  const url = getMagazineArticleUrl(slug);

  return (
    <Item>
      {slug && <Hyperlink to={url} className="dummy-btn" aria-label={title} />}
      {featuredImage && <img src={getArtworkUrl(featuredImage)} alt="" />}
      <Subheader>
        <ArticleSubheader category={category} />
      </Subheader>
      {title && <h2>{title}</h2>}
      {excerpt && (
        <Body className="preview">
          <MDReactComponent text={excerpt} />
        </Body>
      )}
      <ReadMore />
    </Item>
  );
};

ArticleGridItem.propTypes = {
  content: PropTypes.object,
};

export default ArticleGridItem;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/article/ArticleGridItem.js